/* eslint-disable import/no-duplicates */
import MultiCoinStakeDelegate from '@/config/MultiCoinStakeDelegateAbi.json'
import PosAbi from '@/config/PosAbi.json'
import RecordAirDrop from '@/config/RecordAirDropAbi.json'
import StoremanGroupDelegateAbi from '@/config/StoremanGroupDelegateAbi.json'
import StoremanGroupDelegate from '@/config/StoremanGroupDelegateAbi.json'
import XWanFarmingAbi from '@/config/XWanFarming.json'
import XWANSwapAbi from '@/config/XWanToken.abi.json'
import type { RawObject } from '@/types'

export const config: RawObject<RawObject<any>> = {
  // Ethereum Main Network (Mainnet)
  '1': {
    MultiCoinStakeDelegate: {
      addr: '0x71d53A174B7FeC5115FD36A01FB8D905A97a5702',
      abi: MultiCoinStakeDelegate,
    },
    tokenAddrArr: {
      ETH: '0x0000000000000000000000000000000000000000',
      USDT: '0xdac17f958d2ee523a2206206994597c13d831ec7',
      USDC: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
    },
  },
  // Rinkeby Test Network
  '4': {
    MultiCoinStakeDelegate: {
      addr: '0x71d53A174B7FeC5115FD36A01FB8D905A97a5702',
      abi: MultiCoinStakeDelegate,
    },
    tokenAddrArr: {
      ETH: '0x0000000000000000000000000000000000000000',
      USDT: '0x28c96b26f6df3cf57a0a4e8fef02e9295e9ca458',
      USDC: '0x6f2ccb2a1f800705fd70fd77f821078ec9d19f07',
    },
  },
  // Wanchain Main Network
  '888': {
    gwan: 'https://gwan-ssl.wandevs.org:56891',
    RecordAirDrop: {
      addr: '0x69210E65afE612b47C6bAb5D8DE241b7eCE46c51',
      abi: RecordAirDrop,
    },
    StoremanGroupDelegate: {
      addr: '0x1E7450D5d17338a348C5438546f0b4D0A5fbeaB6',
      abi: StoremanGroupDelegate,
    },
    tokenAddrArr: {
      ETH: '0x0000000000000000000000000000000000000000',
      USDT: '0x3D5950287b45F361774E5fB6e50d70eEA06Bc167',
      USDC: '0x52A9CEA01c4CBDd669883e41758B8eB8e8E2B34b',
      xWAN: '0x2eA407Aa69be7367BF231E76B51fab9eC436766c',
    },
    PosContract: {
      addr: '0x00000000000000000000000000000000000000DA',
      abi: PosAbi,
    },
    StoremanContract: {
      addr: '0x1E7450D5d17338a348C5438546f0b4D0A5fbeaB6',
      abi: StoremanGroupDelegateAbi,
    },
    XWanFarmingContract: {
      pool: {
        BTC: {
          contract: '0x9E2C89d3b48ecB0761764D6a17594dA74f20f3Bb',
          addr: '0x50c439B6d602297252505a6799d84eA5928bCFb6',
          rewardAddr: '0x50c439B6d602297252505a6799d84eA5928bCFb6',
          stakeAddr: '0x2eA407Aa69be7367BF231E76B51fab9eC436766c',
        },
        ETH: {
          contract: '0xaeC46cd03C3489EF8C2061E66D3d57FA0171387D',
          addr: '0xE3aE74D1518A76715aB4C7BeDF1af73893cd435A',
          rewardAddr: '0xE3aE74D1518A76715aB4C7BeDF1af73893cd435A',
          stakeAddr: '0x2eA407Aa69be7367BF231E76B51fab9eC436766c',
        },
        USDT: {
          contract: '0x3167219355f3532B8B37e24213118A0898AdcdFB',
          addr: '0x11e77E27Af5539872efEd10abaA0b408cfd9fBBD',
          rewardAddr: '0x11e77E27Af5539872efEd10abaA0b408cfd9fBBD',
          stakeAddr: '0x2eA407Aa69be7367BF231E76B51fab9eC436766c',
        },
        USDC: {
          contract: '0x47047A990523F08743245160BD07dEcC442efA9C',
          addr: '0x52A9CEA01c4CBDd669883e41758B8eB8e8E2B34b',
          rewardAddr: '0x52A9CEA01c4CBDd669883e41758B8eB8e8E2B34b',
          stakeAddr: '0x2eA407Aa69be7367BF231E76B51fab9eC436766c',
        },
        wanBTC: {
          contract: '0x6bcae52a20d3E7C1a2eBFfEf11e0026501979F03',
          addr: '0x50c439B6d602297252505a6799d84eA5928bCFb6',
          rewardAddr: '0x2eA407Aa69be7367BF231E76B51fab9eC436766c',
          stakeAddr: '0x50c439B6d602297252505a6799d84eA5928bCFb6',
        },
        wanETH: {
          contract: '0x2C2dffc78340068c61A706d900578Cf6Fd3Bc07F',
          addr: '0xE3aE74D1518A76715aB4C7BeDF1af73893cd435A',
          rewardAddr: '0x2eA407Aa69be7367BF231E76B51fab9eC436766c',
          stakeAddr: '0xE3aE74D1518A76715aB4C7BeDF1af73893cd435A',
        },
        wanUSDT: {
          contract: '0x812C7F30a67598e32a351a64495F8426AB83Ff20',
          addr: '0x11e77E27Af5539872efEd10abaA0b408cfd9fBBD',
          rewardAddr: '0x2eA407Aa69be7367BF231E76B51fab9eC436766c',
          stakeAddr: '0x11e77E27Af5539872efEd10abaA0b408cfd9fBBD',
        },
        wanUSDC: {
          contract: '0x45eda9edA919c5977f0a55f2BD69494B72cc232F',
          addr: '0x52A9CEA01c4CBDd669883e41758B8eB8e8E2B34b',
          rewardAddr: '0x2eA407Aa69be7367BF231E76B51fab9eC436766c',
          stakeAddr: '0x52A9CEA01c4CBDd669883e41758B8eB8e8E2B34b',
        },
      },
      abi: XWanFarmingAbi,
    },
    XWANSwapContract: {
      addr: '0x2eA407Aa69be7367BF231E76B51fab9eC436766c',
      abi: XWANSwapAbi,
    },
  },
  // Wanchain Test Network
  '999': {
    gwan: 'https://gwan-ssl.wandevs.org:46891',
    RecordAirDrop: {
      addr: '0x69210E65afE612b47C6bAb5D8DE241b7eCE46c51',
      abi: RecordAirDrop,
    },
    StoremanGroupDelegate: {
      addr: '0xaA5A0f7F99FA841F410aafD97E8C435c75c22821',
      abi: StoremanGroupDelegate,
    },
    tokenAddrArr: {
      ETH: '0x0000000000000000000000000000000000000000',
      USDT: '0x28c96b26f6df3cf57a0a4e8fef02e9295e9ca458',
      USDC: '0x6f2ccb2a1f800705fd70fd77f821078ec9d19f07',
      xWAN: '0xfC4e87889dd6799211FEa8c4De1c28F0f1b331bc',
    },
    PosContract: {
      addr: '0x00000000000000000000000000000000000000DA',
      abi: PosAbi,
    },
    StoremanContract: {
      addr: '0xaA5A0f7F99FA841F410aafD97E8C435c75c22821',
      abi: StoremanGroupDelegateAbi,
    },
    XWanFarmingContract: {
      pool: {
        BTC: {
          contract: '0xBeaE94298a2d5B3457066b939Fc0f9aB3f8Dd424',
          addr: '0x07FDb4e8f8E420d021B9abEB2B1f6DcE150Ef77c',
          rewardAddr: '0x07FDb4e8f8E420d021B9abEB2B1f6DcE150Ef77c',
          stakeAddr: '0xfC4e87889dd6799211FEa8c4De1c28F0f1b331bc',
        },
        ETH: {
          contract: '0xfcF8a0225aFac81046EC6e10660a364F46285A87',
          addr: '0x48344649B9611a891987b2Db33fAada3AC1d05eC',
          rewardAddr: '0x48344649B9611a891987b2Db33fAada3AC1d05eC',
          stakeAddr: '0xfC4e87889dd6799211FEa8c4De1c28F0f1b331bc',
        },
        USDT: {
          contract: '0xaa19e84399AFC2373F640e0f584424BCC2884B79',
          addr: '0x3D5950287b45F361774E5fB6e50d70eEA06Bc167',
          rewardAddr: '0x3D5950287b45F361774E5fB6e50d70eEA06Bc167',
          stakeAddr: '0xfC4e87889dd6799211FEa8c4De1c28F0f1b331bc',
        },
        USDC: {
          contract: '0xEb2d8076A6805F4095f547f887C2CE13556792b1',
          addr: '0x7fF465746e4F47e1CbBb80c864CD7DE9F13337fE',
          rewardAddr: '0x7fF465746e4F47e1CbBb80c864CD7DE9F13337fE',
          stakeAddr: '0xfC4e87889dd6799211FEa8c4De1c28F0f1b331bc',
        },
        wanBTC: {
          contract: '0x0B132E42Da8864ad0e9Ee1b705BF7CA49bFC336d',
          addr: '0x07FDb4e8f8E420d021B9abEB2B1f6DcE150Ef77c',
          rewardAddr: '0xfC4e87889dd6799211FEa8c4De1c28F0f1b331bc',
          stakeAddr: '0x07FDb4e8f8E420d021B9abEB2B1f6DcE150Ef77c',
        },
        wanETH: {
          contract: '0xcfd74D60e0b8a20b90d33611288d3DF6531895FD',
          addr: '0x48344649B9611a891987b2Db33fAada3AC1d05eC',
          rewardAddr: '0xfC4e87889dd6799211FEa8c4De1c28F0f1b331bc',
          stakeAddr: '0x48344649B9611a891987b2Db33fAada3AC1d05eC',
        },
        wanUSDT: {
          contract: '0x07c8Ac280D94Ca4D1f58C75BaEF65ee1C250316F',
          addr: '0x3D5950287b45F361774E5fB6e50d70eEA06Bc167',
          rewardAddr: '0xfC4e87889dd6799211FEa8c4De1c28F0f1b331bc',
          stakeAddr: '0x3D5950287b45F361774E5fB6e50d70eEA06Bc167',
        },
        wanUSDC: {
          contract: '0xA9bbf88a9797c14AFCB2aA1BBC523FDde9A26AF1',
          addr: '0x7fF465746e4F47e1CbBb80c864CD7DE9F13337fE',
          rewardAddr: '0xfC4e87889dd6799211FEa8c4De1c28F0f1b331bc',
          stakeAddr: '0x7fF465746e4F47e1CbBb80c864CD7DE9F13337fE',
        },
      },
      abi: XWanFarmingAbi,
    },
    XWANSwapContract: {
      addr: '0xfC4e87889dd6799211FEa8c4De1c28F0f1b331bc',
      abi: XWANSwapAbi,
    },
  },
}

export const tokensName = [
  'ethereum',
  'tether',
  'usd-coin',
  'wanchain',
  'bitcoin',
] as const // "wanchain" always be the last one
export const tokensSymbol = ['WAN', 'USDT', 'USDC'] as const
export const newTokensSymbol = ['WAN', 'USDT', 'USDC', 'xWAN'] as const

export const getDecimal = new Map([
  ['ETH', 18],
  ['USDT', 6],
  ['USDC', 6],
  ['WAN', 18],
  ['xWAN', 18],
  ['BTC', 8],
  ['wanUSDT', 6],
  ['wanUSDC', 6],
  ['wanETH', 18],
  ['wanBTC', 8],
])

export const getTokenName = new Map([
  ['ETH', 'ethereum'],
  ['USDT', 'tether'],
  ['USDC', 'usd-coin'],
  ['BTC', 'bitcoin'],
  ['xWAN', 'wanchain'],
  ['wanUSDT', 'tether'],
  ['wanUSDC', 'usd-coin'],
  ['wanETH', 'ethereum'],
  ['wanBTC', 'bitcoin'],
])

export const getCorrespondChain = new Map([
  ['1', '888'],
  ['4', '999'],
])

export const ETHGAS = '1000000'

export const MAINNET_INFO = {
  chainId: '0x378',
  chainName: 'Wanchain',
  nativeCurrency: {
    name: 'WAN',
    symbol: 'WAN',
    decimals: 18,
  },
  rpcUrls: ['https://gwan-ssl.wandevs.org:56891/'],
  blockExplorerUrls: ['https://www.wanscan.org'],
}

export const TESTNET_INFO = {
  chainId: '0x3e7',
  chainName: 'Wanchain Testnet',
  nativeCurrency: {
    name: 'WAN',
    symbol: 'WAN',
    decimals: 18,
  },
  rpcUrls: ['https://gwan-ssl.wandevs.org:46891/'],
  blockExplorerUrls: ['https://testnet.wanscan.org'],
}

export const PoSDataToolTip = [
  'This indicates the number of WAN staked in the node (including delegations)',
  'This represents the remaining amount available for delegation.',
  "This indicates the node's online rate, where an activity level of 100% means the node is continuously online and operating normally, and an activity level of 0% means the node is completely inactive. The closer the activity level is to 100%, the higher the node's activity.",
  "This represents the lock-up period set by the node, which ranges from 7 to 90 days. The longer the lock-up period, the higher the node's yield rate. The average yield rate for a 90-day lock-up period is 1.5 times that of a 7-day period.",
  "This represents the delegation fee rate currently set by the node. This fee is deducted from the delegator's daily earnings. For example, if a delegator earns 10 WAN and the fee rate is 10%, the actual earnings would be 9 WAN.",
  "This indicates the maximum delegation fee rate that can be set by the node. Node operators can adjust the delegation fee by one percentage point daily, but it cannot exceed the node's maximum fee. The maximum fee is determined when the node is created and cannot be changed.",
  'This indicates the current status of the node. "Working" means operating normally.',
  'This indicates when the node will exit. N/A means the node currently has no plans to exit.',
]

export const BridgeDataToolTip = [
  'This indicates the number of WAN staked in the node (including delegations)',
  'This represents the remaining amount available for delegation.',
  "This indicates the node's online rate, where an activity level of 100% means the node is continuously online and operating normally, and an activity level of 0% means the node is completely inactive. The closer the activity level is to 100%, the higher the node's activity.",
  "This represents the delegation fee rate currently set by the bridge. This fee is deducted from the delegator's daily earnings. For example, if a delegator earns 10 WAN and the fee rate is 10%, the actual earnings would be 9 WAN.",
  'This indicates the current status of the node. "Working" means operating normally.',
  'This indicates if the node is automatically eligible for election in the next cycle. True means that the node is already eligible and that the operator does not need to take any action.',
]

export const MINDAYS = 7
export const MAXDAYS = 90
export const MIN_OSM_STAKE_APPEND = 100
export const OSM_STATUS = [
  'None',
  'Initializing',
  'Selecting',
  'Failed',
  'Selected',
  'Ready',
  'Quitting',
  'Quitted',
]
export const INIT_GROUPID =
  '0x0000000000000000000000000000000000000000000000000000000000000000'
